<template>
  <v-container fluid grid-list-xl pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-menu style="margin-left: 4% !important" bottom left>
          <v-btn slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              @click="generateExcel"
              v-if="
                electronicDocumentsPaging &&
                electronicDocumentsPaging.length > 0
              "
            >
              <v-list-tile-title>Generar archivo excel</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              @click="generatePdf"
              v-if="
                electronicDocumentsPaging &&
                electronicDocumentsPaging.length > 0
              "
            >
              <v-list-tile-title>Generar archivo pdf</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-container fluid>
        <v-layout row wrap align-center justify-center fill-height>
          <v-flex lg6 xs2>
            <v-btn
              style="margin: 0px"
              flat
              icon
              color="primary"
              v-on:click="refresh"
            >
              <v-icon>cached</v-icon>
            </v-btn>
          </v-flex>
          <v-flex lg6 xs10 text-lg-right>
            <v-text-field
              style="padding: 0px; margin: 0px"
              id="searchBox"
              single-line
              v-model="searchText"
              placeholder="Buscar"
              append-icon="search"
              light
              hide-details
              @click:append="search()"
              @keyup.enter="search()"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider style="margin: 0px"></v-divider>
      <v-toolbar
        flat
        height="50"
        style="background: #fff; border: 0"
      >
        <v-flex pl-4>
          <v-form data-vv-scope="query">
            <v-layout align-center justify-center class="document-state">
              <span
                >Firmados
                <v-btn
                  class="notification-icon ml-2 mr-2"
                  small
                  icon
                  slot="activator"
                  >{{ summary.signed }}</v-btn
                >
              </span>
              <span
                >Pendientes
                <v-btn
                  class="notification-icon ml-2 mr-2"
                  small
                  icon
                  slot="activator"
                  >{{ summary.pendding }}</v-btn
                >
              </span>
              <span
                >Expirados
                <v-btn
                  class="notification-icon ml-2 mr-2"
                  small
                  icon
                  slot="activator"
                  >{{ summary.expired }}</v-btn
                >
              </span>
              <span
                >Con Error
                <v-btn
                  class="notification-icon ml-2 mr-2"
                  small
                  icon
                  slot="activator"
                  >{{ summary.error }}</v-btn
                >
              </span>
            </v-layout>
          </v-form>
        </v-flex>
      </v-toolbar>
      <v-card-text style="padding-top: 0px">
        <v-data-table
          flat
          :items="electronicDocumentsPaging"
          :pagination.sync="pagination"
          :rows-per-page-items="pagination.rowsPerPageItems"
          :total-items="pagination.totalItems"
          :headers="headers"
          class="v-table-list theme--light table-default"
        >
          <template slot="headers" scope="props">
            <tr class="border-buttom">
              <!-- style="border:1px #d2d5d8 solid" -->
              <th
                v-for="(header, i) in props.headers"
                :key="i"
                :class="[
                  'column',
                    header.align == 'right'
                      ? 'text-xs-right'
                      : header.align == 'left'
                      ? 'text-xs-left'
                      : 'text-xs-center',
                    header.value === pagination.sortBy ? 'active' : '',
                  header.sortable
                    ? 'sortable' + pagination.descending
                      ? ' desc'
                      : ' asc' + header.value === pagination.sortBy
                      ? ' active'
                      : ''
                    : '',
                ]"
                @click="changeSort(header)"
              >
                {{ header.text }}
                <v-icon v-if="header.sortable">arrow_upward</v-icon>
              </th>
            </tr>
          </template>
          <template slot="items" scope="props">
            <tr
              :active="props.selected"
              @click="props.selected = !props.selected"
            >
              <!-- <td class="text-xs-left 1%">{{ props.item.referenceId }}</td> -->
              <td class="text-xs-left cut-text">
                {{ props.item.codigo }}
              </td>
              <td class="text-xs-left cut-text">
                {{ props.item.identification }}
              </td>
              <td class="text-xs-left cut-text">
                {{ props.item.clientName }}
              </td>
              <td class="text-xs-left cut-text">
                {{ props.item.email }}
              </td>
              <td class="text-xs-left cut-text">
                {{ props.item.documentType }}
              </td>
              <td class="text-xs-left cut-text">
                {{ props.item.orderNumber }}
              </td>
              <td class="text-xs-center cut-text">
                {{ props.item.totalDocuments }}
              </td>
              <td class="text-xs-center cut-text">
                {{ nzDate(props.item.modificationDate) }}
              </td>
              <td class="text-xs-left cut-text">
                {{ props.item.fvcStatus }}
              </td>
              <td class="text-xs-left cut-text">
                {{ props.item.signStatus }}
              </td>
              <td class="text-xs-left cut-text">
                <!-- <v-btn
                  small
                  text
                  icon
                  fab
                  title="Ver Documentos"
                  @click="viewActionsOpenDialog(props.item.referenceId)"
                >
                  <v-icon dark large outline color="#00aeef">visibility</v-icon>
                </v-btn> -->
                <v-btn icon small class="pa-1" title="Ver Documentos" @click="viewActionsOpenDialog(props.item.referenceId)">
                  <v-avatar size="30">
                  <img src="/static/img/ver.png" width="30" height="30" style="float: left;">
                  </v-avatar>
                </v-btn>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <div>{{ $t("message.noElectronicDocuments") }}</div>
          </template>
          <template slot="pageText" slot-scope="props"
            >{{ props.pageStart }} - {{ props.pageStop }}
            {{ $t("message.of") }} {{ props.itemsLength }}</template
          >
        </v-data-table>
        <DocumentActionsModal ref="documentActionsModal"></DocumentActionsModal>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import DocumentActionsModal from "./DocumentActionsModal";
import { downloadPDF } from "@/common/helpers/helpers";
import { downloadEXCEL } from "@/common/helpers/helpers";

export default {
  components: {
    DocumentActionsModal,
  },
  computed: {
    ...mapGetters([
      "loadingElectronicDocuments",
      "agencyId",
      "agency",
      "agencyName",
      "summary",
      "electronicDocumentsFileExcel",
      "electronicDocumentsFilePdf",
    ]),
    pagination: {
      get: function () {
        return this.$store.getters.paginationElectronicDocuments;
      },
      set: function (value) {
        this.$store.commit("setElectronicDocumentsPaging", value);
      },
    },
    electronicDocumentsPaging() {
      return this.$store.getters.electronicDocumentsPaging;
    },
  },
  mounted() {
    this.getSummary();
  },
  watch: {
    pagination: {
      handler() {
        this.querySearch();
      },
      deep: true,
    },
    loadingElectronicDocuments(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    // eslint-disable-next-line no-unused-vars
    agency(val) {
      this.getSummary();
      this.querySearch();
    },
  },
  methods: {
    viewActionsOpenDialog(referenceId) {
      this.$refs.documentActionsModal.openDialog(referenceId);
    },

    search() {
      let val = this.searchText;
      if (val != "") {
        if (val.length >= 3) {
          let command = null;
          let value = null;
          for (let i = 0; i < this.commands.length; i++) {
            // eslint-disable-next-line no-unused-vars
            const element = this.commands[i];
            const index = val.indexOf(this.commands[i].langES);
            if (index === 0) {
              let size = this.commands[i].langES.length;
              command = this.commands[i].langEN;
              value = val.slice(size);
              break;
            }
          }
          if (command !== null && value !== null && value !== "") {
            this.filters[command] = value;
          } else if (val.indexOf("/") !== 0 && val !== null && val !== "") {
            this.filters.nombreCliente = val;
          } else {
            let emptySearch = false;
            this.filters.idReferencia = "";
            this.filters.identificacion = "";
            this.filters.nombreCliente = "";
            if (!emptySearch) {
              return;
            }
          }
          this.querySearch();
        }
      } else {
        this.filters.idReferencia = "";
        this.filters.identificacion = "";
        this.filters.nombreCliente = "";
        this.querySearch();
      }
      this.searchAux = true;
    },
    clearQuery() {
      this.searchText = "";
    },
    nzDate: nzDate,
    openDialog() {
      this.$refs.confirmDialog.openDialog();
    },
    changeSort(column) {
      if (column.sortable == true) {
        if (this.pagination.sortBy === column.header) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column.header;
          this.pagination.descending = false;
        }
      }
    },
    refresh() {
      this.getSummary();
      this.querySearch();
    },
    filter() {
      this.querySearch();
    },
    getSummary() {
      this.$store.dispatch("getSummary", this.filters);
    },
    querySearch() {
      this.filters.query = this.searchText;
      this.$store.dispatch("queryElectronicDocuments", this.filters);
    },

    generateExcel() {
      let query = this.searchText;
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch("downloadExcel", query).then((res) => {
        if (this.electronicDocumentsFileExcel.byteLength < 100) {
          this.$root.$emit("showSnackBar", "No existen datos", "warning");
          return;
        }
        let fecha = new Date();           
        let fechaTexto = ((fecha.getDate()) > 9 ? '' : '0') + (fecha.getDate()) + ((fecha.getMonth() + 1) > 9 ? '' : '0') + (fecha.getMonth() + 1) + fecha.getFullYear() +  "" + fecha.getHours() +  "" + fecha.getMinutes()
        downloadEXCEL(
          this.electronicDocumentsFileExcel,
          "Documentoselectronicos"+fechaTexto+".xlsx"
        );
      });
    },

    generatePdf() {
      let query = this.searchText;
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch("downloadPdf", query).then((res) => {
        if (this.electronicDocumentsFilePdf.byteLength < 100) {
          this.$root.$emit("showSnackBar", "No existen datos", "warning");
          return;
        }
        let fecha = new Date();           
        let fechaTexto = ((fecha.getDate()) > 9 ? '' : '0') + (fecha.getDate()) + ((fecha.getMonth() + 1) > 9 ? '' : '0') + (fecha.getMonth() + 1) + fecha.getFullYear() +  "" + fecha.getHours() +  "" + fecha.getMinutes()
        downloadPDF(
          this.electronicDocumentsFilePdf,
          "Documentoselectronicos"+fechaTexto+".pdf"
        );
      });
    },
  },
  data() {
    return {
      searchText: "",
      commands: [
        { langEN: "idReferencia", langES: "/Id Referencia " },
        { langEN: "identificacion", langES: "/Identificación " },
        { langEN: "nombreCliente", langES: "/Nombre cliente " },
      ],
      filters: {
        query: "",
        idReferencia: "",
        identificacion: "",
        nombreCliente: "",
        idUsuario: 0,
        idAgencia: 0,
        aps: "",
      },
      searchValue: "",
      headers: [
        // {
        //   align: "left",
        //   sortable: false,
        //   text: i18n.t("message.electronicDocumentReferenceId"),
        //   value: "referenceId",
        //   width: "20%"
        // },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.electronicDocumentCodigo"),
          value: "codigo",
          width: "15%",
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.electronicDocumentIdentification"),
          value: "identification",
          width: "15%",
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.electronicDocumentClientName"),
          value: "clientName",
          width: "20%",
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.electronicDocumentEmail"),
          value: "email",
          width: "15%",
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.electronicDocumentDocumentType"),
          value: "documentType",
          width: "20%",
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.electronicDocumentOrderNumber"),
          value: "orderNumber",
          width: "10%",
        },
        {
          align: "center",
          sortable: false,
          text: i18n.t("message.electronicDocumentTotalDocuments"),
          value: "totalDocuments",
          width: "10%",
        },
        {
          align: "center",
          sortable: false,
          text: i18n.t("message.electronicDocumentModificationDate"),
          value: "modificationDate",
          width: "20%",
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.electronicDocumentFvcStatus"),
          value: "fvcStatus",
          width: "20%",
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.electronicDocumentSignStatus"),
          value: "signStatus",
          width: "20%",
        },
      ],
    };
  },
};
</script>
<style >
.theme--light.v-label {
  color: #0a62b1;
  font-size: 12px;
}
.theme-- .v-input--selection-controls__ripple {
  padding: 0px;
  margin: 0px;
}
.v-input--selection-controls__input {
  margin-right: 0px;
}

.document-state h2 {
  color: #519ddf;
}

.document-state span {
  margin: 0px 5px;
  font-size: 14px;
  margin-top: 20px;
  padding-bottom: 5px;
  color: rgb(24, 58, 112);
}

.notification-icon {
  background-color: #081e3f;
  color: #ffffff !important;
}

.v-btn__content {
  font-size: 9px;
}

.v-toolbar__title {
  overflow: none;
}

.v-card__text {
    padding: 16px;
    padding-top: 5px;
    width: 100%;
}
/* .v-icon{
  font-size: 19px
} */
</style>